import { GreyStrokeInfoIcon } from 'assets/icons';
import { PortalPopover } from 'components';
import { PopoverArrowTypes } from 'constants/common';
import { FC, useState } from 'react';

interface ServiceFeeToolTipProps {
  width?: string;
  arrowOffset?: string;
  offset?: string;
}

const ServiceFeeToolTip: FC<ServiceFeeToolTipProps> = () => {
  const [showTooltip, setShowTooltip] = useState(false);

  const handleShowTooltip = () => {
    setShowTooltip(true);
  };

  const handleCloseTooltip = () => {
    setShowTooltip(false);
  };

  const anchorComponent = () => (
    <div onMouseEnter={handleShowTooltip} onMouseLeave={handleCloseTooltip} className="cursor-pointer">
      <GreyStrokeInfoIcon className="shrink-0" />
    </div>
  );

  return (
    <PortalPopover
      anchorComponent={anchorComponent}
      show={showTooltip}
      onTogglePopover={handleShowTooltip}
      onClosePopover={handleCloseTooltip}
      highlightAnchor={false}
      offset={{ top: 30, left: -117.5 }}
      width="w-[235px]"
      padding="px-3 py-[10px]"
      showArrow={true}
      arrowType={PopoverArrowTypes.TOP}
      arrowOffset="left-1/2 -translate-x-1/2"
      arrowClassName="border-l border-t border-[#ACB5BD]"
      containerClassName="border border-[#ACB5BD]">
      <div className="w-fit whitespace-normal p-1 text-sbase text-primaryText">
        Owners or Admins can control Service fees applied to all invoices. Service fee settings can be updated under
        Team Settings &gt; Invoice Settings
      </div>
    </PortalPopover>
  );
};

export default ServiceFeeToolTip;
